import React, { useEffect, useState } from 'react';

import './style.sass';
import Link from 'next/link';
import BasicLink from '../../../../../../core/BasicLink';

function CommonNav({ stepOne, stepTwo, stepThree, className = '', link1, link2, link3 }) {
    const [path, setPath] = useState('');

    useEffect(() => {
        switch (stepThree.toLowerCase()) {
            case 'маркетинг': {
                setPath('marketing');
                break;
            }

            case 'разработка': {
                setPath('development');
                break;
            }

            case 'продукты': {
                setPath('products');
                break;
            }
            default: {
                setPath('');
            }
        }
    }, []);

    return (
        <div className={`nav ${className}`}>
            <BasicLink className="nav__link" href={link1}>
                {stepOne}
            </BasicLink>{' '}
            /{' '}
            <BasicLink className="nav__link" href={link2}>
                {stepTwo}
            </BasicLink>{' '}
            {link3 && (
                <>
                    /{' '}
                    <BasicLink className="nav__link" href={`${link2}/${path}`}>
                        {stepThree}
                    </BasicLink>
                </>
            )}
        </div>
    );
}

export default CommonNav;
